import { ModelCollection } from '/@/modules/core/app/models/ModelCollection';
import { ExtractedAsset } from '@/modules/ai/models/ExtractedAsset';

export class ExtractedAssetCollection extends ModelCollection<ExtractedAsset> {
  constructor(items: ExtractedAsset[] | ExtractedAssetCollection | null = null) {
    super(items, ExtractedAsset);
  }

  static mapModel(
    items: ExtractedAsset[] | ExtractedAssetCollection | null = null
  ): ExtractedAssetCollection {
    return new this(items);
  }

  get pendingAssets(): ExtractedAsset[] {
    return this.items?.filter((asset: ExtractedAsset): boolean => !asset.isValidated) ?? [];
  }

  get validatedAssets(): ExtractedAsset[] {
    return this.items?.filter((asset: ExtractedAsset): boolean => !!asset.isValidated) ?? [];
  }

  get areAllValidated(): boolean {
    return this.hasItems && this.pendingAssets.length === 0;
  }
}
